import React from 'react';
import { createFromIconfontCN } from '@ant-design/icons';
import './index.less';
// antd 字体图标
const IconFont = createFromIconfontCN({
  scriptUrl: [
    '//at.alicdn.com/t/c/font_4742956_zafcglcxe3.js', // 天猫超市分采通
    '//at.alicdn.com/t/c/font_4285415_z461gquclpb.js', // 智鲤主应用
    '//at.alicdn.com/t/c/font_4647340_abrc1tzanze.js', // 璇玑·AI-移动端
  ],
});

interface MainProps {
  [key: string]: any;
  type: string;
}
const Icon: React.FC<MainProps> = (props) => <IconFont {...props} />;
export default Icon;
